import React from 'react'
import PropTypes from 'prop-types'

import './Hero.scss'

import { Img } from '@components/shared/elements'

class Hero extends React.Component {


  render() {

    const { title, image, cta, align } = this.props

    const customClass = (align === 'left' || align === 'right') ? `align-${align}` : ''

    return (

      <div className='hero'>
        <figure>
          {image &&
            <Img src={image} alt={(title) ? title : ''}  className={(customClass) ? customClass : ''} lazyload={false} />
          }
          <figcaption className={(customClass) ? customClass : ''}>
            <div className='hero__content'>
              {title &&
                <header>{title}</header>
              }
              {this.props.children &&
                <div className='text'>
                  {this.props.children}
                </div>
              }
              {cta &&
                <div className='cta'>
                  {cta}
                </div>
              }
            </div>
          </figcaption>
        </figure>
      </div>

    )
  }
}

Hero.propTypes = {
  title: PropTypes.any,
  image: PropTypes.string,
}

export default Hero



// WEBPACK FOOTER //
// ./src/components/shared/elements/Hero/Hero.js